<template>
  <v-bottom-nav :value="true"
                :active.sync="navSelection"
                :class="{'dark-mode':$store.state.NightMode.topNav == 'dark-mode','light-mode':$store.state.NightMode.topNav == 'light-mode'}"
                fixed height="62" >
    <v-btn flat value="home" @click="$router.push({ path: '/dashboard/MainNav' })">
      <span>Home</span>
      <v-badge color="green" overlap>
        <span slot="badge" v-if="mainMenuBadge !== ''"> {{ mainMenuBadge }} </span>
        <v-icon>home</v-icon>
      </v-badge>
    </v-btn>
    <!--<v-btn flat color="teal" value="extension" @click="$router.push({ path: '/dashboard/Extensions' })">
      <span>Extensions</span>
      <v-badge color="red" overlap>
        <span slot="badge" v-if="extensionsBadge !== ''"> {{ extensionsBadge }} </span>
        <v-icon>extension</v-icon>
      </v-badge>
    </v-btn>-->
    <!--<v-btn flat color="teal" value="budgetdata" @click="$router.push({ path: '/dashboard/BudgetData' })">
      <span>Budget Data</span>
      <v-badge color="red" overlap>
        <span slot="badge" v-if="budgetDataBadge !== ''"> {{ budgetDataBadge }} </span>
        <v-icon>assessment</v-icon>
      </v-badge>
    </v-btn>-->
    <!--<v-btn flat color="teal" value="reminder" @click="$router.push({ path: '/dashboard/Reminders' })">
      <span> Reminder </span>
      <v-badge color="red" overlap>
        <span slot="badge" v-if="notificationBadge !== ''"> {{ notificationBadge }} </span>
        <v-icon>alarm</v-icon>
      </v-badge>
    </v-btn>-->
  </v-bottom-nav>
</template>

<script>
  export default {
    data() {
      return {
        mainMenuBadge: '',
        extensionsBadge: '3',
        budgetDataBadge: '1',
        notificationBadge: '2',

        navSelection: ''
      }
    }
  }
</script>

<style scoped>
  .dark-mode {
    background-color: #212121;
  }
</style>




// WEBPACK FOOTER //
// src/components/dashboard/BottomNav.vue